export const buildTransferEditFormData = (state: any, event: any, driversList: any[], idTransfer: string) => {

  const startDate = (state.startDate || event?.startDateTime?.split('T')[0] || '').split(' ')[0];
  const startTime = state.startTime || event?.origin?.transferItemRequestId?.startTime;
  const endTime = state.time_end_suggested || event?.origin?.transferItemRequestId?.endTime;

  const scheduleTransferDateTime = `${startDate}T${startTime.length === 5 ? startTime + ':00' : startTime}`;
  const scheduleTransferEndDateTime = `${startDate}T${endTime.length === 5 ? endTime + ':00' : endTime}`;

  let driver = state.driver || event?.origin?.transferItemRequestId?.driver;
  let foundDriver = null;
  if (typeof driver === 'number' && Array.isArray(driversList)) {
    foundDriver = driversList.find((d) => d.personId === driver || d.id === driver);
  }
  if (foundDriver) {
    driver = {
      personId: foundDriver.personId || foundDriver.id,
      firstName: foundDriver.firstName || foundDriver.nombre || '',
      lastName: foundDriver.lastName || foundDriver.apellido || '',
    };
  }
  if (!driver || typeof driver === 'number') driver = null;

  let companyIdPartnership = event?.origin?.transferItemRequestId?.companyIdPartnership;
  if (companyIdPartnership && companyIdPartnership.name) {
    companyIdPartnership = {
      companyId: companyIdPartnership.companyId,
      companyName: companyIdPartnership.name,
    };
  }

  let hospital = event?.origin?.transferItemRequestId?.hospital;
  if (hospital && hospital.businessName) {
    hospital = {
      hospitalId: hospital.hospitalId,
      hospitalName: hospital.businessName,
    };
  }

  let transferId = null;
  let transferIdnum = idTransfer;

  if (transferIdnum) {
    const transferIdValue = typeof transferIdnum === 'string' ? parseInt(transferIdnum) : transferIdnum;
    const companyId = companyIdPartnership?.companyId || event?.origin?.transferItemRequestId?.companyIdPartnership?.companyId;
    if (companyId) {
      transferId = { transferId: transferIdValue, companyId };
    }
  }

  let weekDays = event?.origin?.transferItemRequestId?.weekDays;
  if (Array.isArray(weekDays) && weekDays.length === 0) weekDays = null;
  if (typeof weekDays === 'string' && weekDays.trim() === '') weekDays = null;

  const transferItemRequestId = {
    ...event?.origin?.transferItemRequestId,
    transferId,
    startTime,
    endTime,
    driver,
    startDate,
    endDate: startDate,
    companyIdPartnership,
    hospital,
    processingScheduleType: 'INTRADAY',
    transferItemRequestStatus: 'APPROVED',
    weekDays,
  };

  delete transferItemRequestId.name;
  delete transferItemRequestId.timeZone;
  delete transferItemRequestId.daylightSavingTime;
  delete transferItemRequestId.startDateTimeDST;
  delete transferItemRequestId.endDateTimeDST;
  delete transferItemRequestId.scheudleAlterTimeAllowance;
  delete transferItemRequestId.quantityHourToFinishedSchedule;
  delete transferItemRequestId.scheduleGapMinutes;
  delete transferItemRequestId.rejectReasonTransferItemRequestId;

  const result = {
    transferScheduleId: event?.id,
    transferItemRequestId,
    driver,
    scheduleTransferDateTime,
    scheduleTransferEndDateTime,
  };

  return result;
} 